<div *ngIf="products && products.length !== 0"
     class="last-deals" fxFlex="100" fxLayout="column">

  <h5 class="last-deals__title">
    {{ 'CUSTOM_HUB.LAST_DEALS_PRODUCTS' | translate }}
  </h5>

  <app-product-carousel
    [isMobile]="isMobile"
    [isDesktop]="isDesktop"
    [products]="products"
    (productClicked)="onProductClick($event.product, $event.priceType, $event.index)"
    (productCarouselPrev)="onProductCarouselPrev()"
    (productCarouselNext)="onProductCarouselNext()">
  </app-product-carousel>
</div>
